const ConnectionLogos = () => {
	return (
		<>
			<div className="omnisend-icon-wrapper">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					viewBox="0 0 32 32"
					fill="none"
				>
					<path
						d="M16 0C7.184 0 0 7.184 0 16C0 24.816 7.184 32 16 32C24.816 32 32 24.816 32 16C32 7.184 24.816 0 16 0ZM1.616 16C1.616 13.92 2.064 11.936 2.864 10.144L9.728 28.944C4.928 26.608 1.616 21.696 1.616 16ZM16 30.384C14.592 30.384 13.232 30.176 11.936 29.792L16.256 17.248L20.672 29.36C20.704 29.424 20.736 29.504 20.768 29.552C19.28 30.096 17.68 30.384 16 30.384ZM17.984 9.248C18.848 9.2 19.632 9.104 19.632 9.104C20.4 9.008 20.32 7.872 19.536 7.92C19.536 7.92 17.2 8.096 15.696 8.096C14.288 8.096 11.904 7.92 11.904 7.92C11.136 7.888 11.04 9.072 11.824 9.12C11.824 9.12 12.56 9.216 13.328 9.264L15.568 15.408L12.416 24.848L7.184 9.248C8.048 9.216 8.832 9.12 8.832 9.12C9.6 9.024 9.52 7.888 8.736 7.936C8.736 7.936 6.4 8.112 4.896 8.112C4.624 8.112 4.304 8.112 3.968 8.096C6.56 4.192 10.976 1.616 16 1.616C19.744 1.616 23.152 3.04 25.712 5.392C25.648 5.392 25.584 5.376 25.52 5.376C24.112 5.376 23.104 6.608 23.104 7.936C23.104 9.12 23.792 10.128 24.512 11.312C25.056 12.272 25.696 13.504 25.696 15.28C25.696 16.512 25.216 17.936 24.608 19.936L23.168 24.736L17.984 9.248ZM28.624 9.104C30.4211 12.393 30.8632 16.2537 29.8561 19.8638C28.849 23.474 26.4722 26.5483 23.232 28.432L27.632 15.728C28.448 13.68 28.72 12.032 28.72 10.576C28.72 10.048 28.688 9.552 28.624 9.104Z"
						fill="black"
					/>
				</svg>
				<div className="omnisend-spacing-mh-8">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
					>
						<rect x="7" width="2" height="16" fill="#419E9C" />
						<rect
							x="16"
							y="7"
							width="2"
							height="16"
							transform="rotate(90 16 7)"
							fill="#419E9C"
						/>
					</svg>
				</div>

				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="32"
					height="32"
					viewBox="0 0 32 32"
					fill="none"
				>
					<path
						d="M26.4485 0H5.5402C2.48237 0 0 2.48149 0 5.53824V26.4392C0 29.4959 2.48237 31.9774 5.5402 31.9774H7.87588H15.0635V27.398C15.0635 22.9877 14.5219 19.5925 11.2384 18.6225V15.013C16.5755 15.4868 19.2271 19.4572 19.2271 25.988V32H23.5712H26.4598C29.5176 32 32 29.5185 32 26.4618V5.53824C31.9887 2.48149 29.5063 0 26.4485 0ZM16.158 11.5502C14.4654 11.5502 13.0889 10.1741 13.0889 8.4822C13.0889 6.79027 14.4654 5.41417 16.158 5.41417C17.8505 5.41417 19.2158 6.79027 19.2158 8.49348C19.2158 10.1854 17.8505 11.5502 16.158 11.5502Z"
						fill="#1E2423"
					/>
				</svg>
			</div>
		</>
	);
};

export default ConnectionLogos;
